import { index, union, stack as d3stack } from 'd3';
import getBandwidth from '../../../primitives/shape/utils/getBandwidth';
import stackOffset from '../../../primitives/shape/utils/stackOffset';
import stackOrder from '../../../primitives/shape/utils/stackOrder';
export function getHorizontalBarStacks(data, order, offset, xAccessor, colorAccessor, valueAccessor, xScale, yScale, colorScale, x0, x1) {
  const keyUnion = union(data.map(d => colorAccessor(d)));

  // Keys cannot be duplicate here.
  const indexData = index(data, d => xAccessor(d), d => colorAccessor(d));

  // TODO: Fix these data definitions
  const stack = d3stack().keys(keyUnion).value((_ref, key) => {
    let [, group] = _ref;
    return valueAccessor(group.get(key));
  });
  if (order) stack.order(stackOrder(order));
  if (offset) stack.offset(stackOffset(offset));
  const stacks = stack(indexData);
  const barHeight = getBandwidth(yScale);
  const barStacks = stacks.reduce((stack, categoryStack) => {
    categoryStack.forEach(bar => {
      const key = bar.data[0];
      const barWidth = (xScale(x1(bar)) || 0) - (xScale(x0(bar)) || 0);
      const barX = xScale(x0(bar));
      const barY = 'bandwidth' in xScale ? yScale(bar.data[0]) : Math.max(yScale(bar.data[0]) || 0);
      if (!stack.hasOwnProperty(key)) {
        stack[key] = {
          key,
          bars: []
        };
      }
      if (barWidth !== 0) {
        stack[key].bars.forEach(bar => {
          bar.rounded = false;
        });
      }
      stack[key].bars.push({
        bar,
        key: categoryStack.key,
        datum: bar.data[1].get(categoryStack.key),
        height: barHeight,
        width: barWidth,
        yValue: bar.data[0],
        xValue: x1(bar) - x0(bar),
        label: categoryStack.key,
        x: barX || 0,
        y: barY || 0,
        color: colorScale(categoryStack.key),
        rounded: barWidth !== 0
      });
      if (stack[key].bars.length > 0) {
        stack[key].bars[0].rounded = true;
      }
    });
    return stack;
  }, {});
  return Object.values(barStacks);
}